"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const last_1 = require("../arrays/last");
/**
 * Return the given string, but unquoted.
 *
 * @example
 *
 *   unquote('"hello"')
 *   //=> "hello"
 *
 *   unquote("hello")
 *   //=> "hello"
 *
 *   unquote("'hello'")
 *   //=> "hello"
 *
 *   unquote("'hello")
 *   //=> "'hello"
 */
function unquote(str) {
    const [firstChar, ...rest] = str.split("");
    const lastChar = last_1.last(rest);
    if (firstChar === lastChar) {
        return str.replace(/["']/g, "");
    }
    return str;
}
exports.unquote = unquote;
//# sourceMappingURL=unquote.js.map